import React, { useState } from 'react'

const Tabs = ({ tabs }) => {
  const [selectedTab, setSelectedTab] = useState(tabs[0].id)
  const { component: Component } = tabs.find((x) => x.id === selectedTab)

  return (
    <div>
      <nav className="tabs_container">
        {tabs.map((tab) => (
          <button
            className={selectedTab === tab.id ? 'activeTab' : 'tab'}
            onClick={() => setSelectedTab(tab.id)}
            key={tab.id}
            type="button"
          >
            {tab.label}
          </button>
        ))}
      </nav>
      <div className="tabs-body">
        <Component />
      </div>
    </div>
  )
}

export default Tabs
